import { render, staticRenderFns } from "./OtherUserTemplateConfirm.vue?vue&type=template&id=4d02d638&lang=pug"
import script from "./OtherUserTemplateConfirm.vue?vue&type=script&lang=ts"
export * from "./OtherUserTemplateConfirm.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserTemplateConfirm.vue?vue&type=style&index=0&id=4d02d638&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports